export const DEFAULT_META_TRANSACTION_BLOCK_HEIGHT_TTL = 100n;
export const MAX_GAS = 300000000000000n;
export const PAGODA_RPC_ENDPOINTS_MAINNET = [
    'https://rpc.near.org',
    'https://rpc.mainnet.pagoda.co',
];
export const PAGODA_RPC_ARCHIVAL_ENDPOINTS_MAINNET = [
    'https://archival-rpc.near.org',
];
export const PAGODA_RPC_ENDPOINTS_TESTNET = [
    'https://rpc.testnet.near.org',
    'https://rpc.testnet.pagoda.co',
];
export const PAGODA_RPC_ARCHIVAL_ENDPOINTS_TESTNET = [
    'https://archival-rpc.testnet.near.org',
];
export const KITWALLET_FUNDED_TESTNET_ACCOUNT_ENDPOINT = 'https://testnet-api.kitwallet.app/account';
